import Vue from 'vue'

const eventBus = {
  install () {
    Vue.prototype.$eventBus = new Vue()
  }
}

Vue.use(eventBus)



// WEBPACK FOOTER //
// ./src/plugins/event-bus.js